"use client";
import { FC, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

import QRCodeSvg from "@/public/icon/qRCode";
import CallCenter from "@/public/icon/callCenter";
import ArrowSvg from "@/public/icon/arrow";

const iconList = [QRCodeSvg, CallCenter, ArrowSvg];

export const FixedTool: FC = () => {
  const [isTop, setIsTop] = useState(true);
  const scrollFunction = () => {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    setIsTop(!scrollTop);
  };

  useEffect(() => {
    scrollFunction();
    window.addEventListener("scroll", scrollFunction);
    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  const backToTop = (idx: number) => {
    if (idx !== 2) return;
    const target = 0;
    const start = window.scrollY;
    const distance = target - start;
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const duration = (400 * scrollTop) / document.documentElement.clientHeight;
    let startTime = 0;

    const step = (currentTime: number) => {
      if (startTime === 0) {
        startTime = currentTime;
      }

      const progress = currentTime - startTime;
      const easeInOutQuad = (t: number) =>
        t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      let newPosition = start + distance * easeInOutQuad(progress / duration);
      if (newPosition < 5) newPosition = 0;

      window.scrollTo(0, newPosition);
      if (progress < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  return (
    <div className="right-5 top-[50%] z-[999] fixed text-white translate-y-[-50%] hidden md:block">
      <ul className="flex flex-col flex-center space-y-[10px]">
        {iconList.map((IconSvg, idx) => (
          <li
            key={idx}
            className="cursor-pointer"
            style={{ zIndex: 999 - idx }}
            onClick={() => backToTop(idx)}
          >
            <div
              className={cn(
                `hover:border-transparent hover:bg-[#004EA2] 
                 border border-[#CACACA] p-3 rounded-full bg-white  
                 shadow-[2px_2px_4px_0_rgba(0,0,0,0.08)]`,
                "transition-[opacity,transform] duration-1000 ease-in-out",
                "group relative",
                idx === 2 && isTop
                  ? "translate-y-[-100%] opacity-0"
                  : "translate-y-0 opacity-100"
              )}
            >
              {idx === 0 ? (
                <Image
                  src="/qRCode.jpg"
                  className="
                    scale-[5]
                    origin-bottom-right
                    absolute left-[-10px] top-[250%]
                    translate-x-[-100%] 
                    translate-y-[-50%] 
                    hidden group-hover:block
                    shadow-[1px_0px_2px_1px_rgba(0,0,0,0.1)]
                    "
                  alt="qRCode"
                  width="384"
                  height="384"
                  quality={100}
                />
              ) : (
                ""
              )}
              <IconSvg
                className={cn(
                  "w-6 h-6 text-[#989898] group-hover:text-white",
                  idx === 2 && "-rotate-90"
                )}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

